'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var Ref = (function () {
  function Ref(object) {
    _classCallCheck(this, Ref);

    this.__ctorName = 'Ref';
    this._id = null;
    this._item = null;

    if (typeof object === 'string') {
      this._id = object;
    } else if (object != null && typeof object === 'object' && object.hasOwnProperty('_id')) {
      this._id = object._id;
      this._item = object;
    }
  }

  _createClass(Ref, [{
    key: 'get',
    value: function get() {
      return this._item;
    }
  }, {
    key: 'toJSON',
    value: function toJSON() {
      if (this._item) {
        return {
          ref: this._id,
          item: this._item
        };
      } else {
        return {
          ref: this._id
        };
      }
    }
  }, {
    key: 'id',
    get: function get() {
      return this._id;
    }
  }], [{
    key: 'fromJSON',
    value: function fromJSON(obj) {
      var ref = new Ref(obj.ref);
      ref._item = obj.item || null;
      return ref;
    }
  }]);

  return Ref;
})();

exports.Ref = Ref;


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-data-webmethod-structures/lib/ref.js
// module id = 72
// module chunks = 0